import React from "react";
import { PaginationParameter } from "entities/UIModel";
import { PaginationProviderActionType } from "utils/data/enum";


type State = {
  signaturePagination?: PaginationParameter;
  signatureDefaultPagination?: PaginationParameter;
}

type Action = {
  type: PaginationProviderActionType;
  signaturePagination?: PaginationParameter;
  signatureDefaultPagination?: PaginationParameter;
}

type Context = {
  state: State;
  dispatch: React.Dispatch<Action>;
}

const initialState: State = {
  signaturePagination: { 
    page: 1, 
    rowsPerPage: 10, 
    sortColumn: "signatureImageName", 
  },
  signatureDefaultPagination: { 
    page: 1, 
    rowsPerPage: 10, 
    sortColumn: "signatureName", 
  },
}

const PaginationContext = React.createContext<Context | undefined>(undefined);
PaginationContext.displayName = "PaginationContext";

const paginationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case PaginationProviderActionType.INIT_SIGNATURE_GRID:
      return {
        ...state,
        signaturePagination: {
          page: 1,
          rowsPerPage: 10,
          sortColumn: "signatureImageName",
        }
      }
    case PaginationProviderActionType.INIT_SIGNATURE_DEFAULT_GRID:
      return {
        ...state,
        signatureDefaultPagination: {
          page: 1,
          rowsPerPage: 10,
          sortColumn: "signatureName",
        },
      }      
    case PaginationProviderActionType.SET_SIGNATURE_GRID:
      return {
        ...state,
        signaturePagination: action.signaturePagination,
      }      
    case PaginationProviderActionType.SET_SIGNATURE_DEFAULT_GRID:
      return {
        ...state,
        signatureDefaultPagination: action.signatureDefaultPagination,
      }         
    default:
      throw new Error("Invalid action type");
  }
}


const PaginationProvider = (props: any) => {
  const [state, dispatch] = React.useReducer(paginationReducer, initialState);
  return (
    <PaginationContext.Provider {...props} value={{ state, dispatch }} />
  );
};

const usePaginationProvider = () => {
  const context = React.useContext(PaginationContext);
  if (!context) {
    throw new Error(
      "useConfigurationProvider must be used within a <ConfigurationProvider>"
    );
  }

  return context;
};

export { PaginationProvider, usePaginationProvider };
